import service from '@/utils/request';

// @Tags partner
// @Summary 获取充值列表(不分页)
// @Security ApiKeyAuth
// @Produce  application/json
// @Success 200 {string} string "{"success":true,"data":{},"msg":"返回成功"}"
// @Router /xcpGameManager/getPayItemList [post]
export var getPayItemList = function getPayItemList(data) {
  return service({
    url: "/xcpGameManager/getPayItemList",
    method: 'post',
    data: data
  });
};

//获取充值项列表
export var getPayItemListWithPage = function getPayItemListWithPage(data) {
  return service({
    url: "/xcpGameManager/getPayItemListWithPage",
    method: 'post',
    data: data
  });
};

//审核充值申请
export var approvePayRequest = function approvePayRequest(data) {
  return service({
    url: "/xcpOpsManager/approvePayRequest",
    method: 'post',
    data: data
  });
};

//获取充值申请列表
export var getPayRequest = function getPayRequest(data) {
  return service({
    url: "/xcpOpsManager/getPayRequest",
    method: 'post',
    data: data
  });
};

//保存充值申请
export var savePayRequest = function savePayRequest(data) {
  return service({
    url: "/xcpOpsManager/savePayRequest",
    method: 'post',
    data: data
  });
};

//根据Id查找申请列表
export var getPayRequestOne = function getPayRequestOne(data) {
  return service({
    url: "/xcpOpsManager/getPayRequestOne",
    method: 'post',
    data: data
  });
};